/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const CreateSavedViewDocument = gql`
    mutation CreateSavedView($input: CreateUserSavedViewInput!) {
  createSavedView(input: $input) {
    id
  }
}
    `;
export type CreateSavedViewMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>;

/**
 * __useCreateSavedViewMutation__
 *
 * To run a mutation, you first call `useCreateSavedViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedViewMutation, { data, loading, error }] = useCreateSavedViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedViewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>(CreateSavedViewDocument, options);
      }
export type CreateSavedViewMutationHookResult = ReturnType<typeof useCreateSavedViewMutation>;
export type CreateSavedViewMutationResult = Apollo.MutationResult<GraphqlTypes.CreateSavedViewMutation>;
export type CreateSavedViewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateSavedViewMutation, GraphqlTypes.CreateSavedViewMutationVariables>;
export const CreateTicketExportDocument = gql`
    mutation CreateTicketExport($filters: TicketFilters!, $sort: TicketSortInput, $ticketKeys: [String!]) {
  createTicketExport(filters: $filters, sort: $sort, ticketKeys: $ticketKeys)
}
    `;
export type CreateTicketExportMutationFn = Apollo.MutationFunction<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>;

/**
 * __useCreateTicketExportMutation__
 *
 * To run a mutation, you first call `useCreateTicketExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketExportMutation, { data, loading, error }] = useCreateTicketExportMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      ticketKeys: // value for 'ticketKeys'
 *   },
 * });
 */
export function useCreateTicketExportMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>(CreateTicketExportDocument, options);
      }
export type CreateTicketExportMutationHookResult = ReturnType<typeof useCreateTicketExportMutation>;
export type CreateTicketExportMutationResult = Apollo.MutationResult<GraphqlTypes.CreateTicketExportMutation>;
export type CreateTicketExportMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CreateTicketExportMutation, GraphqlTypes.CreateTicketExportMutationVariables>;
export const GetTicketsDocument = gql`
    query GetTickets($filters: TicketFilters, $sort: TicketSortInput, $limit: Int, $pageToken: String, $excludeAllCompleted: Boolean) {
  tickets(
    filters: $filters
    sort: $sort
    limit: $limit
    pageToken: $pageToken
    excludeAllCompleted: $excludeAllCompleted
  ) {
    tickets {
      id
      key
      description
      ticketType
      workType
      status
      statusCategoryName
      customers
      entityName
      createdAt
      updated
      jiraLink
      isPrimary
      isReviewer
      faPreparer
      faReviewer
      requestedBy
      assignedTo {
        id
        displayName
        email
      }
      managerOfAssignedTo {
        displayName
        email
      }
      client {
        id
        name
        type
        contactEmail
      }
      manager {
        id
        displayName
        email
        department
      }
      progress {
        completedTasks
        totalTasks
        percentage
      }
      pastDue
      timeElapsed
      dueDate
    }
    nextPageToken
    hasNextPage
    totalCount
    fieldMetadata {
      fieldName
      jiraDisplayName
      jiraFieldId
      fieldType
    }
  }
}
    `;

/**
 * __useGetTicketsQuery__
 *
 * To run a query within a React component, call `useGetTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      pageToken: // value for 'pageToken'
 *      excludeAllCompleted: // value for 'excludeAllCompleted'
 *   },
 * });
 */
export function useGetTicketsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>(GetTicketsDocument, options);
      }
export function useGetTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>(GetTicketsDocument, options);
        }
// @ts-ignore
export function useGetTicketsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>;
export function useGetTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketsQuery | undefined, GraphqlTypes.GetTicketsQueryVariables>;
export function useGetTicketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>(GetTicketsDocument, options);
        }
export type GetTicketsQueryHookResult = ReturnType<typeof useGetTicketsQuery>;
export type GetTicketsLazyQueryHookResult = ReturnType<typeof useGetTicketsLazyQuery>;
export type GetTicketsSuspenseQueryHookResult = ReturnType<typeof useGetTicketsSuspenseQuery>;
export type GetTicketsQueryResult = Apollo.QueryResult<GraphqlTypes.GetTicketsQuery, GraphqlTypes.GetTicketsQueryVariables>;
export const GetSavedViewDocument = gql`
    query GetSavedView {
  getSavedView {
    id
    configuration
  }
}
    `;

/**
 * __useGetSavedViewQuery__
 *
 * To run a query within a React component, call `useGetSavedViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedViewQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>(GetSavedViewDocument, options);
      }
export function useGetSavedViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>(GetSavedViewDocument, options);
        }
// @ts-ignore
export function useGetSavedViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>;
export function useGetSavedViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetSavedViewQuery | undefined, GraphqlTypes.GetSavedViewQueryVariables>;
export function useGetSavedViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>(GetSavedViewDocument, options);
        }
export type GetSavedViewQueryHookResult = ReturnType<typeof useGetSavedViewQuery>;
export type GetSavedViewLazyQueryHookResult = ReturnType<typeof useGetSavedViewLazyQuery>;
export type GetSavedViewSuspenseQueryHookResult = ReturnType<typeof useGetSavedViewSuspenseQuery>;
export type GetSavedViewQueryResult = Apollo.QueryResult<GraphqlTypes.GetSavedViewQuery, GraphqlTypes.GetSavedViewQueryVariables>;
export const GetTicketExportDocument = gql`
    query GetTicketExport($exportId: String!) {
  getTicketExport(exportId: $exportId) {
    status
    downloadUrl
    errorMessage
  }
}
    `;

/**
 * __useGetTicketExportQuery__
 *
 * To run a query within a React component, call `useGetTicketExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketExportQuery({
 *   variables: {
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useGetTicketExportQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables> & ({ variables: GraphqlTypes.GetTicketExportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>(GetTicketExportDocument, options);
      }
export function useGetTicketExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>(GetTicketExportDocument, options);
        }
// @ts-ignore
export function useGetTicketExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>;
export function useGetTicketExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetTicketExportQuery | undefined, GraphqlTypes.GetTicketExportQueryVariables>;
export function useGetTicketExportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>(GetTicketExportDocument, options);
        }
export type GetTicketExportQueryHookResult = ReturnType<typeof useGetTicketExportQuery>;
export type GetTicketExportLazyQueryHookResult = ReturnType<typeof useGetTicketExportLazyQuery>;
export type GetTicketExportSuspenseQueryHookResult = ReturnType<typeof useGetTicketExportSuspenseQuery>;
export type GetTicketExportQueryResult = Apollo.QueryResult<GraphqlTypes.GetTicketExportQuery, GraphqlTypes.GetTicketExportQueryVariables>;
export const GetFilterOptionsDocument = gql`
    query GetFilterOptions($projectKey: String!) {
  filterOptions(projectKey: $projectKey) {
    projectKey
    issuetype {
      value
    }
    status {
      value
    }
    assignee {
      value
      displayName
    }
    customers {
      value
    }
    entityName {
      value
    }
    isPrimary {
      value
      displayName
    }
    isReviewer {
      value
      displayName
    }
    faReviewer {
      value
      displayName
    }
    faPreparer {
      value
      displayName
    }
  }
}
    `;

/**
 * __useGetFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterOptionsQuery({
 *   variables: {
 *      projectKey: // value for 'projectKey'
 *   },
 * });
 */
export function useGetFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables> & ({ variables: GraphqlTypes.GetFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
      }
export function useGetFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
        }
// @ts-ignore
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>;
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFilterOptionsQuery | undefined, GraphqlTypes.GetFilterOptionsQueryVariables>;
export function useGetFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>(GetFilterOptionsDocument, options);
        }
export type GetFilterOptionsQueryHookResult = ReturnType<typeof useGetFilterOptionsQuery>;
export type GetFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetFilterOptionsLazyQuery>;
export type GetFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetFilterOptionsSuspenseQuery>;
export type GetFilterOptionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetFilterOptionsQuery, GraphqlTypes.GetFilterOptionsQueryVariables>;
export const GetFieldMetadataDocument = gql`
    query GetFieldMetadata($projectKey: String!) {
  tickets(filters: {projectKeys: [$projectKey]}, limit: 0) {
    fieldMetadata {
      fieldName
      jiraDisplayName
      jiraFieldId
      fieldType
    }
  }
}
    `;

/**
 * __useGetFieldMetadataQuery__
 *
 * To run a query within a React component, call `useGetFieldMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFieldMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFieldMetadataQuery({
 *   variables: {
 *      projectKey: // value for 'projectKey'
 *   },
 * });
 */
export function useGetFieldMetadataQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables> & ({ variables: GraphqlTypes.GetFieldMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>(GetFieldMetadataDocument, options);
      }
export function useGetFieldMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>(GetFieldMetadataDocument, options);
        }
// @ts-ignore
export function useGetFieldMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>;
export function useGetFieldMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFieldMetadataQuery | undefined, GraphqlTypes.GetFieldMetadataQueryVariables>;
export function useGetFieldMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>(GetFieldMetadataDocument, options);
        }
export type GetFieldMetadataQueryHookResult = ReturnType<typeof useGetFieldMetadataQuery>;
export type GetFieldMetadataLazyQueryHookResult = ReturnType<typeof useGetFieldMetadataLazyQuery>;
export type GetFieldMetadataSuspenseQueryHookResult = ReturnType<typeof useGetFieldMetadataSuspenseQuery>;
export type GetFieldMetadataQueryResult = Apollo.QueryResult<GraphqlTypes.GetFieldMetadataQuery, GraphqlTypes.GetFieldMetadataQueryVariables>;
export const PlaceholderQueryDocument = gql`
    query PlaceholderQuery {
  __typename
}
    `;

/**
 * __usePlaceholderQueryQuery__
 *
 * To run a query within a React component, call `usePlaceholderQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaceholderQueryQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>(PlaceholderQueryDocument, options);
      }
export function usePlaceholderQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>(PlaceholderQueryDocument, options);
        }
// @ts-ignore
export function usePlaceholderQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>;
export function usePlaceholderQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PlaceholderQueryQuery | undefined, GraphqlTypes.PlaceholderQueryQueryVariables>;
export function usePlaceholderQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>(PlaceholderQueryDocument, options);
        }
export type PlaceholderQueryQueryHookResult = ReturnType<typeof usePlaceholderQueryQuery>;
export type PlaceholderQueryLazyQueryHookResult = ReturnType<typeof usePlaceholderQueryLazyQuery>;
export type PlaceholderQuerySuspenseQueryHookResult = ReturnType<typeof usePlaceholderQuerySuspenseQuery>;
export type PlaceholderQueryQueryResult = Apollo.QueryResult<GraphqlTypes.PlaceholderQueryQuery, GraphqlTypes.PlaceholderQueryQueryVariables>;
export const GetProjectStatisticsDocument = gql`
    query GetProjectStatistics($projectId: String!) {
  projectStatistics(projectId: $projectId) {
    projectId
    projectKey
    projectName
    issueTypeStatistics {
      issueTypeName
      issueTypeValue
      activeCount
      completedCount
      totalCount
    }
  }
}
    `;

/**
 * __useGetProjectStatisticsQuery__
 *
 * To run a query within a React component, call `useGetProjectStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectStatisticsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables> & ({ variables: GraphqlTypes.GetProjectStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
      }
export function useGetProjectStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
        }
// @ts-ignore
export function useGetProjectStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>;
export function useGetProjectStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetProjectStatisticsQuery | undefined, GraphqlTypes.GetProjectStatisticsQueryVariables>;
export function useGetProjectStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, options);
        }
export type GetProjectStatisticsQueryHookResult = ReturnType<typeof useGetProjectStatisticsQuery>;
export type GetProjectStatisticsLazyQueryHookResult = ReturnType<typeof useGetProjectStatisticsLazyQuery>;
export type GetProjectStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetProjectStatisticsSuspenseQuery>;
export type GetProjectStatisticsQueryResult = Apollo.QueryResult<GraphqlTypes.GetProjectStatisticsQuery, GraphqlTypes.GetProjectStatisticsQueryVariables>;
export const GetLinkedIssuesDocument = gql`
    query GetLinkedIssues($issueKey: String!, $commentsStartAt: Int, $commentsMaxResults: Int) {
  linkedIssues(
    issueKey: $issueKey
    commentsStartAt: $commentsStartAt
    commentsMaxResults: $commentsMaxResults
  ) {
    parentKey
    totalCount
    items {
      key
      comments {
        id
        body
        author {
          accountId
          displayName
          emailAddress
        }
        created
        updated
      }
      commentsStartAt
      commentsMaxResults
      hasMoreComments
    }
  }
}
    `;

/**
 * __useGetLinkedIssuesQuery__
 *
 * To run a query within a React component, call `useGetLinkedIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedIssuesQuery({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *      commentsStartAt: // value for 'commentsStartAt'
 *      commentsMaxResults: // value for 'commentsMaxResults'
 *   },
 * });
 */
export function useGetLinkedIssuesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables> & ({ variables: GraphqlTypes.GetLinkedIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>(GetLinkedIssuesDocument, options);
      }
export function useGetLinkedIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>(GetLinkedIssuesDocument, options);
        }
// @ts-ignore
export function useGetLinkedIssuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>;
export function useGetLinkedIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedIssuesQuery | undefined, GraphqlTypes.GetLinkedIssuesQueryVariables>;
export function useGetLinkedIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>(GetLinkedIssuesDocument, options);
        }
export type GetLinkedIssuesQueryHookResult = ReturnType<typeof useGetLinkedIssuesQuery>;
export type GetLinkedIssuesLazyQueryHookResult = ReturnType<typeof useGetLinkedIssuesLazyQuery>;
export type GetLinkedIssuesSuspenseQueryHookResult = ReturnType<typeof useGetLinkedIssuesSuspenseQuery>;
export type GetLinkedIssuesQueryResult = Apollo.QueryResult<GraphqlTypes.GetLinkedIssuesQuery, GraphqlTypes.GetLinkedIssuesQueryVariables>;
export const GetLinkedIssueKeysDocument = gql`
    query GetLinkedIssueKeys($issueKey: String!) {
  linkedIssues(issueKey: $issueKey) {
    parentKey
    totalCount
    items {
      key
    }
  }
}
    `;

/**
 * __useGetLinkedIssueKeysQuery__
 *
 * To run a query within a React component, call `useGetLinkedIssueKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedIssueKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedIssueKeysQuery({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *   },
 * });
 */
export function useGetLinkedIssueKeysQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables> & ({ variables: GraphqlTypes.GetLinkedIssueKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>(GetLinkedIssueKeysDocument, options);
      }
export function useGetLinkedIssueKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>(GetLinkedIssueKeysDocument, options);
        }
// @ts-ignore
export function useGetLinkedIssueKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>;
export function useGetLinkedIssueKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetLinkedIssueKeysQuery | undefined, GraphqlTypes.GetLinkedIssueKeysQueryVariables>;
export function useGetLinkedIssueKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>(GetLinkedIssueKeysDocument, options);
        }
export type GetLinkedIssueKeysQueryHookResult = ReturnType<typeof useGetLinkedIssueKeysQuery>;
export type GetLinkedIssueKeysLazyQueryHookResult = ReturnType<typeof useGetLinkedIssueKeysLazyQuery>;
export type GetLinkedIssueKeysSuspenseQueryHookResult = ReturnType<typeof useGetLinkedIssueKeysSuspenseQuery>;
export type GetLinkedIssueKeysQueryResult = Apollo.QueryResult<GraphqlTypes.GetLinkedIssueKeysQuery, GraphqlTypes.GetLinkedIssueKeysQueryVariables>;
export const GetCommentsPaginatedDocument = gql`
    query GetCommentsPaginated($issueKey: String!, $startAt: Int, $maxResults: Int) {
  commentsPaginated(
    issueKey: $issueKey
    startAt: $startAt
    maxResults: $maxResults
  ) {
    comments {
      id
      body
      author {
        accountId
        displayName
        emailAddress
      }
      created
      updated
    }
    startAt
    maxResults
    total
    hasMore
  }
}
    `;

/**
 * __useGetCommentsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetCommentsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsPaginatedQuery({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *      startAt: // value for 'startAt'
 *      maxResults: // value for 'maxResults'
 *   },
 * });
 */
export function useGetCommentsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables> & ({ variables: GraphqlTypes.GetCommentsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>(GetCommentsPaginatedDocument, options);
      }
export function useGetCommentsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>(GetCommentsPaginatedDocument, options);
        }
// @ts-ignore
export function useGetCommentsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>;
export function useGetCommentsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommentsPaginatedQuery | undefined, GraphqlTypes.GetCommentsPaginatedQueryVariables>;
export function useGetCommentsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>(GetCommentsPaginatedDocument, options);
        }
export type GetCommentsPaginatedQueryHookResult = ReturnType<typeof useGetCommentsPaginatedQuery>;
export type GetCommentsPaginatedLazyQueryHookResult = ReturnType<typeof useGetCommentsPaginatedLazyQuery>;
export type GetCommentsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetCommentsPaginatedSuspenseQuery>;
export type GetCommentsPaginatedQueryResult = Apollo.QueryResult<GraphqlTypes.GetCommentsPaginatedQuery, GraphqlTypes.GetCommentsPaginatedQueryVariables>;
export const GetFundAdminServicesDocument = gql`
    query GetFundAdminServices($serviceIds: [String!]) {
  fundAdminServices(serviceIds: $serviceIds) {
    edges {
      node {
        id
        externalTicketIdentifier
        details
        status
        isPublished
        createdAt
        modifiedAt
        requestType
        activities {
          authorName
          id
          createdAt
          message
          isUserComment
        }
        documents {
          id
          documentVersionId
          documentVersion {
            name
            downloadUrl
            id
          }
          documentType
        }
        objects {
          objectValue {
            ... on UserObjectType {
              id
              fullName
              emailAddress
            }
            ... on AccountObjectType {
              id
              name
            }
            ... on EntityCollectionObjectType {
              id
              name
              entities(fundAdministeredOnly: true) {
                count
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          objectDetails
        }
      }
    }
  }
}
    `;

/**
 * __useGetFundAdminServicesQuery__
 *
 * To run a query within a React component, call `useGetFundAdminServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundAdminServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundAdminServicesQuery({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useGetFundAdminServicesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
      }
export function useGetFundAdminServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
        }
// @ts-ignore
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdminServicesQuery | undefined, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export function useGetFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>(GetFundAdminServicesDocument, options);
        }
export type GetFundAdminServicesQueryHookResult = ReturnType<typeof useGetFundAdminServicesQuery>;
export type GetFundAdminServicesLazyQueryHookResult = ReturnType<typeof useGetFundAdminServicesLazyQuery>;
export type GetFundAdminServicesSuspenseQueryHookResult = ReturnType<typeof useGetFundAdminServicesSuspenseQuery>;
export type GetFundAdminServicesQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundAdminServicesQuery, GraphqlTypes.GetFundAdminServicesQueryVariables>;
export const GetCanopyFundAdminServicesDocument = gql`
    query GetCanopyFundAdminServices($serviceIds: [String!]) {
  canopyFundAdminServices(serviceIds: $serviceIds) {
    edges {
      node {
        id
        externalTicketIdentifier
        details
        status
        isPublished
        createdAt
        modifiedAt
        requestType
        documents {
          id
          documentVersionId
          documentVersion {
            name
            id
            directDownloadUrl
          }
          documentType
        }
        objects {
          objectValue {
            ... on UserObjectType {
              id
              fullName
              emailAddress
            }
            ... on AccountObjectType {
              id
              name
            }
            ... on EntityCollectionObjectType {
              id
              name
              entitiesFromCanopy {
                count
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
          objectDetails
        }
      }
    }
  }
}
    `;

/**
 * __useGetCanopyFundAdminServicesQuery__
 *
 * To run a query within a React component, call `useGetCanopyFundAdminServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanopyFundAdminServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanopyFundAdminServicesQuery({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *   },
 * });
 */
export function useGetCanopyFundAdminServicesQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>(GetCanopyFundAdminServicesDocument, options);
      }
export function useGetCanopyFundAdminServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>(GetCanopyFundAdminServicesDocument, options);
        }
// @ts-ignore
export function useGetCanopyFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>;
export function useGetCanopyFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCanopyFundAdminServicesQuery | undefined, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>;
export function useGetCanopyFundAdminServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>(GetCanopyFundAdminServicesDocument, options);
        }
export type GetCanopyFundAdminServicesQueryHookResult = ReturnType<typeof useGetCanopyFundAdminServicesQuery>;
export type GetCanopyFundAdminServicesLazyQueryHookResult = ReturnType<typeof useGetCanopyFundAdminServicesLazyQuery>;
export type GetCanopyFundAdminServicesSuspenseQueryHookResult = ReturnType<typeof useGetCanopyFundAdminServicesSuspenseQuery>;
export type GetCanopyFundAdminServicesQueryResult = Apollo.QueryResult<GraphqlTypes.GetCanopyFundAdminServicesQuery, GraphqlTypes.GetCanopyFundAdminServicesQueryVariables>;
export const GetChildWorkItemsDocument = gql`
    query GetChildWorkItems($parentIssueKey: String!) {
  childWorkItems(parentIssueKey: $parentIssueKey) {
    parentKey
    items {
      id
      key
      summary
      status
      statusCategoryName
      assignedTo {
        displayName
      }
      fundAdministrationDepartment
    }
  }
}
    `;

/**
 * __useGetChildWorkItemsQuery__
 *
 * To run a query within a React component, call `useGetChildWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildWorkItemsQuery({
 *   variables: {
 *      parentIssueKey: // value for 'parentIssueKey'
 *   },
 * });
 */
export function useGetChildWorkItemsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables> & ({ variables: GraphqlTypes.GetChildWorkItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>(GetChildWorkItemsDocument, options);
      }
export function useGetChildWorkItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>(GetChildWorkItemsDocument, options);
        }
// @ts-ignore
export function useGetChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>;
export function useGetChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetChildWorkItemsQuery | undefined, GraphqlTypes.GetChildWorkItemsQueryVariables>;
export function useGetChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>(GetChildWorkItemsDocument, options);
        }
export type GetChildWorkItemsQueryHookResult = ReturnType<typeof useGetChildWorkItemsQuery>;
export type GetChildWorkItemsLazyQueryHookResult = ReturnType<typeof useGetChildWorkItemsLazyQuery>;
export type GetChildWorkItemsSuspenseQueryHookResult = ReturnType<typeof useGetChildWorkItemsSuspenseQuery>;
export type GetChildWorkItemsQueryResult = Apollo.QueryResult<GraphqlTypes.GetChildWorkItemsQuery, GraphqlTypes.GetChildWorkItemsQueryVariables>;
export const GetFundAdministrationRequestIdDocument = gql`
    query GetFundAdministrationRequestId($issueKey: String!) {
  fundAdministrationRequestId(issueKey: $issueKey) {
    requestId
  }
}
    `;

/**
 * __useGetFundAdministrationRequestIdQuery__
 *
 * To run a query within a React component, call `useGetFundAdministrationRequestIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundAdministrationRequestIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundAdministrationRequestIdQuery({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *   },
 * });
 */
export function useGetFundAdministrationRequestIdQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables> & ({ variables: GraphqlTypes.GetFundAdministrationRequestIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>(GetFundAdministrationRequestIdDocument, options);
      }
export function useGetFundAdministrationRequestIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>(GetFundAdministrationRequestIdDocument, options);
        }
// @ts-ignore
export function useGetFundAdministrationRequestIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>;
export function useGetFundAdministrationRequestIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFundAdministrationRequestIdQuery | undefined, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>;
export function useGetFundAdministrationRequestIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>(GetFundAdministrationRequestIdDocument, options);
        }
export type GetFundAdministrationRequestIdQueryHookResult = ReturnType<typeof useGetFundAdministrationRequestIdQuery>;
export type GetFundAdministrationRequestIdLazyQueryHookResult = ReturnType<typeof useGetFundAdministrationRequestIdLazyQuery>;
export type GetFundAdministrationRequestIdSuspenseQueryHookResult = ReturnType<typeof useGetFundAdministrationRequestIdSuspenseQuery>;
export type GetFundAdministrationRequestIdQueryResult = Apollo.QueryResult<GraphqlTypes.GetFundAdministrationRequestIdQuery, GraphqlTypes.GetFundAdministrationRequestIdQueryVariables>;
export const AddBtsCommentDocument = gql`
    mutation AddBtsComment($issueKey: String!, $body: JSON!, $isInternal: Boolean, $parentCommentId: String, $taskGroup: CommentGroupInput) {
  addBtsComment(
    issueKey: $issueKey
    body: $body
    isInternal: $isInternal
    parentCommentId: $parentCommentId
    taskGroup: $taskGroup
  ) {
    id
    body
    isInternal
    parentCommentId
    created
    updated
    author {
      accountId
      displayName
      emailAddress
    }
  }
}
    `;
export type AddBtsCommentMutationFn = Apollo.MutationFunction<GraphqlTypes.AddBtsCommentMutation, GraphqlTypes.AddBtsCommentMutationVariables>;

/**
 * __useAddBtsCommentMutation__
 *
 * To run a mutation, you first call `useAddBtsCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBtsCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBtsCommentMutation, { data, loading, error }] = useAddBtsCommentMutation({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *      body: // value for 'body'
 *      isInternal: // value for 'isInternal'
 *      parentCommentId: // value for 'parentCommentId'
 *      taskGroup: // value for 'taskGroup'
 *   },
 * });
 */
export function useAddBtsCommentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AddBtsCommentMutation, GraphqlTypes.AddBtsCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AddBtsCommentMutation, GraphqlTypes.AddBtsCommentMutationVariables>(AddBtsCommentDocument, options);
      }
export type AddBtsCommentMutationHookResult = ReturnType<typeof useAddBtsCommentMutation>;
export type AddBtsCommentMutationResult = Apollo.MutationResult<GraphqlTypes.AddBtsCommentMutation>;
export type AddBtsCommentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AddBtsCommentMutation, GraphqlTypes.AddBtsCommentMutationVariables>;
export const GetCommentThreadsDocument = gql`
    query GetCommentThreads($issueKey: String!, $startAt: Int, $maxResults: Int, $includeInternal: Boolean) {
  commentThreads(
    issueKey: $issueKey
    startAt: $startAt
    maxResults: $maxResults
    includeInternal: $includeInternal
  ) {
    comments {
      id
      body
      author {
        accountId
        displayName
        emailAddress
        avatarUrl
      }
      created
      updated
      isInternal
      taskId
      taskLabel
      replies {
        id
        body
        author {
          accountId
          displayName
          emailAddress
          avatarUrl
        }
        created
        updated
        isInternal
        parentCommentId
      }
    }
    total
    hasMore
  }
}
    `;

/**
 * __useGetCommentThreadsQuery__
 *
 * To run a query within a React component, call `useGetCommentThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentThreadsQuery({
 *   variables: {
 *      issueKey: // value for 'issueKey'
 *      startAt: // value for 'startAt'
 *      maxResults: // value for 'maxResults'
 *      includeInternal: // value for 'includeInternal'
 *   },
 * });
 */
export function useGetCommentThreadsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables> & ({ variables: GraphqlTypes.GetCommentThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>(GetCommentThreadsDocument, options);
      }
export function useGetCommentThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>(GetCommentThreadsDocument, options);
        }
// @ts-ignore
export function useGetCommentThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>;
export function useGetCommentThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetCommentThreadsQuery | undefined, GraphqlTypes.GetCommentThreadsQueryVariables>;
export function useGetCommentThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>(GetCommentThreadsDocument, options);
        }
export type GetCommentThreadsQueryHookResult = ReturnType<typeof useGetCommentThreadsQuery>;
export type GetCommentThreadsLazyQueryHookResult = ReturnType<typeof useGetCommentThreadsLazyQuery>;
export type GetCommentThreadsSuspenseQueryHookResult = ReturnType<typeof useGetCommentThreadsSuspenseQuery>;
export type GetCommentThreadsQueryResult = Apollo.QueryResult<GraphqlTypes.GetCommentThreadsQuery, GraphqlTypes.GetCommentThreadsQueryVariables>;
export const RequestDocumentUploadDocument = gql`
    mutation RequestDocumentUpload($input: RequestDocumentUploadInput!) {
  requestDocumentUpload(input: $input) {
    documentId
    uploadUrl
    contentType
    expiresAt
  }
}
    `;
export type RequestDocumentUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.RequestDocumentUploadMutation, GraphqlTypes.RequestDocumentUploadMutationVariables>;

/**
 * __useRequestDocumentUploadMutation__
 *
 * To run a mutation, you first call `useRequestDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDocumentUploadMutation, { data, loading, error }] = useRequestDocumentUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RequestDocumentUploadMutation, GraphqlTypes.RequestDocumentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RequestDocumentUploadMutation, GraphqlTypes.RequestDocumentUploadMutationVariables>(RequestDocumentUploadDocument, options);
      }
export type RequestDocumentUploadMutationHookResult = ReturnType<typeof useRequestDocumentUploadMutation>;
export type RequestDocumentUploadMutationResult = Apollo.MutationResult<GraphqlTypes.RequestDocumentUploadMutation>;
export type RequestDocumentUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RequestDocumentUploadMutation, GraphqlTypes.RequestDocumentUploadMutationVariables>;
export const ConfirmDocumentUploadDocument = gql`
    mutation ConfirmDocumentUpload($documentId: Int!) {
  confirmDocumentUpload(documentId: $documentId) {
    id
    fileName
    status
  }
}
    `;
export type ConfirmDocumentUploadMutationFn = Apollo.MutationFunction<GraphqlTypes.ConfirmDocumentUploadMutation, GraphqlTypes.ConfirmDocumentUploadMutationVariables>;

/**
 * __useConfirmDocumentUploadMutation__
 *
 * To run a mutation, you first call `useConfirmDocumentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDocumentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDocumentUploadMutation, { data, loading, error }] = useConfirmDocumentUploadMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useConfirmDocumentUploadMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ConfirmDocumentUploadMutation, GraphqlTypes.ConfirmDocumentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ConfirmDocumentUploadMutation, GraphqlTypes.ConfirmDocumentUploadMutationVariables>(ConfirmDocumentUploadDocument, options);
      }
export type ConfirmDocumentUploadMutationHookResult = ReturnType<typeof useConfirmDocumentUploadMutation>;
export type ConfirmDocumentUploadMutationResult = Apollo.MutationResult<GraphqlTypes.ConfirmDocumentUploadMutation>;
export type ConfirmDocumentUploadMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ConfirmDocumentUploadMutation, GraphqlTypes.ConfirmDocumentUploadMutationVariables>;
export const AttachDocumentToTaskDocument = gql`
    mutation AttachDocumentToTask($input: AttachDocumentToTaskInput!) {
  attachDocumentToTask(input: $input) {
    id
    taskId
    documentId
    purpose
  }
}
    `;
export type AttachDocumentToTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.AttachDocumentToTaskMutation, GraphqlTypes.AttachDocumentToTaskMutationVariables>;

/**
 * __useAttachDocumentToTaskMutation__
 *
 * To run a mutation, you first call `useAttachDocumentToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachDocumentToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachDocumentToTaskMutation, { data, loading, error }] = useAttachDocumentToTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttachDocumentToTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.AttachDocumentToTaskMutation, GraphqlTypes.AttachDocumentToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.AttachDocumentToTaskMutation, GraphqlTypes.AttachDocumentToTaskMutationVariables>(AttachDocumentToTaskDocument, options);
      }
export type AttachDocumentToTaskMutationHookResult = ReturnType<typeof useAttachDocumentToTaskMutation>;
export type AttachDocumentToTaskMutationResult = Apollo.MutationResult<GraphqlTypes.AttachDocumentToTaskMutation>;
export type AttachDocumentToTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.AttachDocumentToTaskMutation, GraphqlTypes.AttachDocumentToTaskMutationVariables>;
export const DetachDocumentFromTaskDocument = gql`
    mutation DetachDocumentFromTask($taskId: Int!, $documentId: Int!) {
  detachDocumentFromTask(taskId: $taskId, documentId: $documentId)
}
    `;
export type DetachDocumentFromTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.DetachDocumentFromTaskMutation, GraphqlTypes.DetachDocumentFromTaskMutationVariables>;

/**
 * __useDetachDocumentFromTaskMutation__
 *
 * To run a mutation, you first call `useDetachDocumentFromTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachDocumentFromTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachDocumentFromTaskMutation, { data, loading, error }] = useDetachDocumentFromTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDetachDocumentFromTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DetachDocumentFromTaskMutation, GraphqlTypes.DetachDocumentFromTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DetachDocumentFromTaskMutation, GraphqlTypes.DetachDocumentFromTaskMutationVariables>(DetachDocumentFromTaskDocument, options);
      }
export type DetachDocumentFromTaskMutationHookResult = ReturnType<typeof useDetachDocumentFromTaskMutation>;
export type DetachDocumentFromTaskMutationResult = Apollo.MutationResult<GraphqlTypes.DetachDocumentFromTaskMutation>;
export type DetachDocumentFromTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DetachDocumentFromTaskMutation, GraphqlTypes.DetachDocumentFromTaskMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($documentId: Int!) {
  deleteDocument(documentId: $documentId)
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DeleteDocumentMutation, GraphqlTypes.DeleteDocumentMutationVariables>;
export const StartTaskDocument = gql`
    mutation StartTask($taskId: Int!) {
  startTask(taskId: $taskId) {
    id
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type StartTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.StartTaskMutation, GraphqlTypes.StartTaskMutationVariables>;

/**
 * __useStartTaskMutation__
 *
 * To run a mutation, you first call `useStartTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTaskMutation, { data, loading, error }] = useStartTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartTaskMutation, GraphqlTypes.StartTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartTaskMutation, GraphqlTypes.StartTaskMutationVariables>(StartTaskDocument, options);
      }
export type StartTaskMutationHookResult = ReturnType<typeof useStartTaskMutation>;
export type StartTaskMutationResult = Apollo.MutationResult<GraphqlTypes.StartTaskMutation>;
export type StartTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartTaskMutation, GraphqlTypes.StartTaskMutationVariables>;
export const SubmitTaskForReviewDocument = gql`
    mutation SubmitTaskForReview($taskId: Int!, $note: String) {
  submitTaskForReview(taskId: $taskId, note: $note) {
    id
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type SubmitTaskForReviewMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitTaskForReviewMutation, GraphqlTypes.SubmitTaskForReviewMutationVariables>;

/**
 * __useSubmitTaskForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitTaskForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTaskForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTaskForReviewMutation, { data, loading, error }] = useSubmitTaskForReviewMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSubmitTaskForReviewMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitTaskForReviewMutation, GraphqlTypes.SubmitTaskForReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitTaskForReviewMutation, GraphqlTypes.SubmitTaskForReviewMutationVariables>(SubmitTaskForReviewDocument, options);
      }
export type SubmitTaskForReviewMutationHookResult = ReturnType<typeof useSubmitTaskForReviewMutation>;
export type SubmitTaskForReviewMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitTaskForReviewMutation>;
export type SubmitTaskForReviewMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitTaskForReviewMutation, GraphqlTypes.SubmitTaskForReviewMutationVariables>;
export const ApproveTaskDocument = gql`
    mutation ApproveTask($taskId: Int!, $note: String, $nextAssigneeId: Int) {
  approveTask(taskId: $taskId, note: $note, nextAssigneeId: $nextAssigneeId) {
    id
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type ApproveTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.ApproveTaskMutation, GraphqlTypes.ApproveTaskMutationVariables>;

/**
 * __useApproveTaskMutation__
 *
 * To run a mutation, you first call `useApproveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTaskMutation, { data, loading, error }] = useApproveTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      note: // value for 'note'
 *      nextAssigneeId: // value for 'nextAssigneeId'
 *   },
 * });
 */
export function useApproveTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApproveTaskMutation, GraphqlTypes.ApproveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApproveTaskMutation, GraphqlTypes.ApproveTaskMutationVariables>(ApproveTaskDocument, options);
      }
export type ApproveTaskMutationHookResult = ReturnType<typeof useApproveTaskMutation>;
export type ApproveTaskMutationResult = Apollo.MutationResult<GraphqlTypes.ApproveTaskMutation>;
export type ApproveTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApproveTaskMutation, GraphqlTypes.ApproveTaskMutationVariables>;
export const RejectTaskDocument = gql`
    mutation RejectTask($taskId: Int!, $note: String, $rejectionReason: String) {
  rejectTask(taskId: $taskId, note: $note, rejectionReason: $rejectionReason) {
    id
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type RejectTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.RejectTaskMutation, GraphqlTypes.RejectTaskMutationVariables>;

/**
 * __useRejectTaskMutation__
 *
 * To run a mutation, you first call `useRejectTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectTaskMutation, { data, loading, error }] = useRejectTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      note: // value for 'note'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useRejectTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RejectTaskMutation, GraphqlTypes.RejectTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RejectTaskMutation, GraphqlTypes.RejectTaskMutationVariables>(RejectTaskDocument, options);
      }
export type RejectTaskMutationHookResult = ReturnType<typeof useRejectTaskMutation>;
export type RejectTaskMutationResult = Apollo.MutationResult<GraphqlTypes.RejectTaskMutation>;
export type RejectTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RejectTaskMutation, GraphqlTypes.RejectTaskMutationVariables>;
export const ResolveTaskDocument = gql`
    mutation ResolveTask($taskId: Int!, $resolution: String!, $note: String) {
  resolveTask(taskId: $taskId, resolution: $resolution, note: $note) {
    id
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type ResolveTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.ResolveTaskMutation, GraphqlTypes.ResolveTaskMutationVariables>;

/**
 * __useResolveTaskMutation__
 *
 * To run a mutation, you first call `useResolveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveTaskMutation, { data, loading, error }] = useResolveTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      resolution: // value for 'resolution'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useResolveTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ResolveTaskMutation, GraphqlTypes.ResolveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ResolveTaskMutation, GraphqlTypes.ResolveTaskMutationVariables>(ResolveTaskDocument, options);
      }
export type ResolveTaskMutationHookResult = ReturnType<typeof useResolveTaskMutation>;
export type ResolveTaskMutationResult = Apollo.MutationResult<GraphqlTypes.ResolveTaskMutation>;
export type ResolveTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ResolveTaskMutation, GraphqlTypes.ResolveTaskMutationVariables>;
export const HandoffTaskToExternalPartyDocument = gql`
    mutation HandoffTaskToExternalParty($taskId: Int!) {
  handoffTaskToExternalParty(taskId: $taskId) {
    id
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type HandoffTaskToExternalPartyMutationFn = Apollo.MutationFunction<GraphqlTypes.HandoffTaskToExternalPartyMutation, GraphqlTypes.HandoffTaskToExternalPartyMutationVariables>;

/**
 * __useHandoffTaskToExternalPartyMutation__
 *
 * To run a mutation, you first call `useHandoffTaskToExternalPartyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandoffTaskToExternalPartyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handoffTaskToExternalPartyMutation, { data, loading, error }] = useHandoffTaskToExternalPartyMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useHandoffTaskToExternalPartyMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.HandoffTaskToExternalPartyMutation, GraphqlTypes.HandoffTaskToExternalPartyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.HandoffTaskToExternalPartyMutation, GraphqlTypes.HandoffTaskToExternalPartyMutationVariables>(HandoffTaskToExternalPartyDocument, options);
      }
export type HandoffTaskToExternalPartyMutationHookResult = ReturnType<typeof useHandoffTaskToExternalPartyMutation>;
export type HandoffTaskToExternalPartyMutationResult = Apollo.MutationResult<GraphqlTypes.HandoffTaskToExternalPartyMutation>;
export type HandoffTaskToExternalPartyMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.HandoffTaskToExternalPartyMutation, GraphqlTypes.HandoffTaskToExternalPartyMutationVariables>;
export const ClaimTaskDocument = gql`
    mutation ClaimTask($taskId: Int!, $displayName: String) {
  claimTask(taskId: $taskId, displayName: $displayName) {
    id
    assignee {
      id
      displayName
    }
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type ClaimTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.ClaimTaskMutation, GraphqlTypes.ClaimTaskMutationVariables>;

/**
 * __useClaimTaskMutation__
 *
 * To run a mutation, you first call `useClaimTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimTaskMutation, { data, loading, error }] = useClaimTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useClaimTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ClaimTaskMutation, GraphqlTypes.ClaimTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ClaimTaskMutation, GraphqlTypes.ClaimTaskMutationVariables>(ClaimTaskDocument, options);
      }
export type ClaimTaskMutationHookResult = ReturnType<typeof useClaimTaskMutation>;
export type ClaimTaskMutationResult = Apollo.MutationResult<GraphqlTypes.ClaimTaskMutation>;
export type ClaimTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ClaimTaskMutation, GraphqlTypes.ClaimTaskMutationVariables>;
export const BulkClaimTasksDocument = gql`
    mutation BulkClaimTasks($workflowId: Int!) {
  bulkClaimTasks(workflowId: $workflowId) {
    id
    assignee {
      id
      displayName
    }
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type BulkClaimTasksMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkClaimTasksMutation, GraphqlTypes.BulkClaimTasksMutationVariables>;

/**
 * __useBulkClaimTasksMutation__
 *
 * To run a mutation, you first call `useBulkClaimTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkClaimTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkClaimTasksMutation, { data, loading, error }] = useBulkClaimTasksMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useBulkClaimTasksMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkClaimTasksMutation, GraphqlTypes.BulkClaimTasksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkClaimTasksMutation, GraphqlTypes.BulkClaimTasksMutationVariables>(BulkClaimTasksDocument, options);
      }
export type BulkClaimTasksMutationHookResult = ReturnType<typeof useBulkClaimTasksMutation>;
export type BulkClaimTasksMutationResult = Apollo.MutationResult<GraphqlTypes.BulkClaimTasksMutation>;
export type BulkClaimTasksMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkClaimTasksMutation, GraphqlTypes.BulkClaimTasksMutationVariables>;
export const BulkAssignTasksByFamilyDocument = gql`
    mutation BulkAssignTasksByFamily($workflowId: Int!, $faAssigneeId: String, $isAssigneeId: String) {
  bulkAssignTasksByFamily(
    workflowId: $workflowId
    faAssigneeId: $faAssigneeId
    isAssigneeId: $isAssigneeId
  ) {
    id
    assignee {
      id
      displayName
    }
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type BulkAssignTasksByFamilyMutationFn = Apollo.MutationFunction<GraphqlTypes.BulkAssignTasksByFamilyMutation, GraphqlTypes.BulkAssignTasksByFamilyMutationVariables>;

/**
 * __useBulkAssignTasksByFamilyMutation__
 *
 * To run a mutation, you first call `useBulkAssignTasksByFamilyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignTasksByFamilyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignTasksByFamilyMutation, { data, loading, error }] = useBulkAssignTasksByFamilyMutation({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      faAssigneeId: // value for 'faAssigneeId'
 *      isAssigneeId: // value for 'isAssigneeId'
 *   },
 * });
 */
export function useBulkAssignTasksByFamilyMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.BulkAssignTasksByFamilyMutation, GraphqlTypes.BulkAssignTasksByFamilyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.BulkAssignTasksByFamilyMutation, GraphqlTypes.BulkAssignTasksByFamilyMutationVariables>(BulkAssignTasksByFamilyDocument, options);
      }
export type BulkAssignTasksByFamilyMutationHookResult = ReturnType<typeof useBulkAssignTasksByFamilyMutation>;
export type BulkAssignTasksByFamilyMutationResult = Apollo.MutationResult<GraphqlTypes.BulkAssignTasksByFamilyMutation>;
export type BulkAssignTasksByFamilyMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.BulkAssignTasksByFamilyMutation, GraphqlTypes.BulkAssignTasksByFamilyMutationVariables>;
export const ReassignTaskDocument = gql`
    mutation ReassignTask($taskId: Int!, $newAssigneeId: String!, $newAssigneeDisplayName: String, $note: String) {
  reassignTask(
    taskId: $taskId
    newAssigneeId: $newAssigneeId
    newAssigneeDisplayName: $newAssigneeDisplayName
    note: $note
  ) {
    id
    assignee {
      id
      displayName
    }
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type ReassignTaskMutationFn = Apollo.MutationFunction<GraphqlTypes.ReassignTaskMutation, GraphqlTypes.ReassignTaskMutationVariables>;

/**
 * __useReassignTaskMutation__
 *
 * To run a mutation, you first call `useReassignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignTaskMutation, { data, loading, error }] = useReassignTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      newAssigneeId: // value for 'newAssigneeId'
 *      newAssigneeDisplayName: // value for 'newAssigneeDisplayName'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useReassignTaskMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReassignTaskMutation, GraphqlTypes.ReassignTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReassignTaskMutation, GraphqlTypes.ReassignTaskMutationVariables>(ReassignTaskDocument, options);
      }
export type ReassignTaskMutationHookResult = ReturnType<typeof useReassignTaskMutation>;
export type ReassignTaskMutationResult = Apollo.MutationResult<GraphqlTypes.ReassignTaskMutation>;
export type ReassignTaskMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReassignTaskMutation, GraphqlTypes.ReassignTaskMutationVariables>;
export const UpdateChecklistItemDocument = gql`
    mutation UpdateChecklistItem($subtaskId: Int!, $isCompleted: Boolean!, $value: String) {
  updateChecklistItem(
    subtaskId: $subtaskId
    isCompleted: $isCompleted
    value: $value
  ) {
    id
    isCompleted
    value
  }
}
    `;
export type UpdateChecklistItemMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdateChecklistItemMutation, GraphqlTypes.UpdateChecklistItemMutationVariables>;

/**
 * __useUpdateChecklistItemMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistItemMutation, { data, loading, error }] = useUpdateChecklistItemMutation({
 *   variables: {
 *      subtaskId: // value for 'subtaskId'
 *      isCompleted: // value for 'isCompleted'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdateChecklistItemMutation, GraphqlTypes.UpdateChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdateChecklistItemMutation, GraphqlTypes.UpdateChecklistItemMutationVariables>(UpdateChecklistItemDocument, options);
      }
export type UpdateChecklistItemMutationHookResult = ReturnType<typeof useUpdateChecklistItemMutation>;
export type UpdateChecklistItemMutationResult = Apollo.MutationResult<GraphqlTypes.UpdateChecklistItemMutation>;
export type UpdateChecklistItemMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdateChecklistItemMutation, GraphqlTypes.UpdateChecklistItemMutationVariables>;
export const CancelTaskAssignmentDocument = gql`
    mutation CancelTaskAssignment($taskId: Int!) {
  cancelTaskAssignment(taskId: $taskId) {
    id
    assignee {
      id
      displayName
    }
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type CancelTaskAssignmentMutationFn = Apollo.MutationFunction<GraphqlTypes.CancelTaskAssignmentMutation, GraphqlTypes.CancelTaskAssignmentMutationVariables>;

/**
 * __useCancelTaskAssignmentMutation__
 *
 * To run a mutation, you first call `useCancelTaskAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTaskAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTaskAssignmentMutation, { data, loading, error }] = useCancelTaskAssignmentMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCancelTaskAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.CancelTaskAssignmentMutation, GraphqlTypes.CancelTaskAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.CancelTaskAssignmentMutation, GraphqlTypes.CancelTaskAssignmentMutationVariables>(CancelTaskAssignmentDocument, options);
      }
export type CancelTaskAssignmentMutationHookResult = ReturnType<typeof useCancelTaskAssignmentMutation>;
export type CancelTaskAssignmentMutationResult = Apollo.MutationResult<GraphqlTypes.CancelTaskAssignmentMutation>;
export type CancelTaskAssignmentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.CancelTaskAssignmentMutation, GraphqlTypes.CancelTaskAssignmentMutationVariables>;
export const RecordExternalApprovalOnBehalfDocument = gql`
    mutation RecordExternalApprovalOnBehalf($taskId: Int!, $note: String!, $evidenceFileKeys: [String!]) {
  recordExternalApprovalOnBehalf(
    taskId: $taskId
    note: $note
    evidenceFileKeys: $evidenceFileKeys
  ) {
    id
    status
    gpxStatus
    executionState
    availableActions {
      action
      label
      variant
      requiresConfirmation
    }
  }
}
    `;
export type RecordExternalApprovalOnBehalfMutationFn = Apollo.MutationFunction<GraphqlTypes.RecordExternalApprovalOnBehalfMutation, GraphqlTypes.RecordExternalApprovalOnBehalfMutationVariables>;

/**
 * __useRecordExternalApprovalOnBehalfMutation__
 *
 * To run a mutation, you first call `useRecordExternalApprovalOnBehalfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordExternalApprovalOnBehalfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordExternalApprovalOnBehalfMutation, { data, loading, error }] = useRecordExternalApprovalOnBehalfMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      note: // value for 'note'
 *      evidenceFileKeys: // value for 'evidenceFileKeys'
 *   },
 * });
 */
export function useRecordExternalApprovalOnBehalfMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RecordExternalApprovalOnBehalfMutation, GraphqlTypes.RecordExternalApprovalOnBehalfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RecordExternalApprovalOnBehalfMutation, GraphqlTypes.RecordExternalApprovalOnBehalfMutationVariables>(RecordExternalApprovalOnBehalfDocument, options);
      }
export type RecordExternalApprovalOnBehalfMutationHookResult = ReturnType<typeof useRecordExternalApprovalOnBehalfMutation>;
export type RecordExternalApprovalOnBehalfMutationResult = Apollo.MutationResult<GraphqlTypes.RecordExternalApprovalOnBehalfMutation>;
export type RecordExternalApprovalOnBehalfMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RecordExternalApprovalOnBehalfMutation, GraphqlTypes.RecordExternalApprovalOnBehalfMutationVariables>;
export const GetWorkflowFilterOptionsDocument = gql`
    query GetWorkflowFilterOptions {
  workflowFilterOptions {
    statuses {
      value
      displayName
    }
    workflowTypes {
      value
      displayName
    }
    clients {
      value
      displayName
    }
    assignees {
      value
      displayName
    }
  }
}
    `;

/**
 * __useGetWorkflowFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>(GetWorkflowFilterOptionsDocument, options);
      }
export function useGetWorkflowFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>(GetWorkflowFilterOptionsDocument, options);
        }
// @ts-ignore
export function useGetWorkflowFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>;
export function useGetWorkflowFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkflowFilterOptionsQuery | undefined, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>;
export function useGetWorkflowFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>(GetWorkflowFilterOptionsDocument, options);
        }
export type GetWorkflowFilterOptionsQueryHookResult = ReturnType<typeof useGetWorkflowFilterOptionsQuery>;
export type GetWorkflowFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetWorkflowFilterOptionsLazyQuery>;
export type GetWorkflowFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowFilterOptionsSuspenseQuery>;
export type GetWorkflowFilterOptionsQueryResult = Apollo.QueryResult<GraphqlTypes.GetWorkflowFilterOptionsQuery, GraphqlTypes.GetWorkflowFilterOptionsQueryVariables>;
export const DocumentDownloadUrlDocument = gql`
    query DocumentDownloadUrl($id: Int!) {
  documentDownloadUrl(id: $id)
}
    `;

/**
 * __useDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDownloadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.DocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>(DocumentDownloadUrlDocument, options);
      }
export function useDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>(DocumentDownloadUrlDocument, options);
        }
// @ts-ignore
export function useDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>;
export function useDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentDownloadUrlQuery | undefined, GraphqlTypes.DocumentDownloadUrlQueryVariables>;
export function useDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>(DocumentDownloadUrlDocument, options);
        }
export type DocumentDownloadUrlQueryHookResult = ReturnType<typeof useDocumentDownloadUrlQuery>;
export type DocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useDocumentDownloadUrlLazyQuery>;
export type DocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useDocumentDownloadUrlSuspenseQuery>;
export type DocumentDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.DocumentDownloadUrlQuery, GraphqlTypes.DocumentDownloadUrlQueryVariables>;
export const GetControlTowerWorkflowsDocument = gql`
    query GetControlTowerWorkflows($assignedToUserIds: [String!], $assignedToCurrentUser: Boolean, $clientIds: [String!], $statuses: [String!], $workflowTypes: [String!], $dueDateBefore: DateTime, $dueDateAfter: DateTime, $limit: Int, $page: Int, $sortBy: String, $sortDir: String) {
  controlTowerWorkflows(
    assignedToUserIds: $assignedToUserIds
    assignedToCurrentUser: $assignedToCurrentUser
    clientIds: $clientIds
    statuses: $statuses
    workflowTypes: $workflowTypes
    dueDateBefore: $dueDateBefore
    dueDateAfter: $dueDateAfter
    limit: $limit
    page: $page
    sortBy: $sortBy
    sortDir: $sortDir
  ) {
    items {
      id
      sourceId
      title
      templateName
      definitionScope
      definitionVersionNumber
      workflowType
      status
      currentStepName
      currentAssignee {
        id
        displayName
      }
      clientId
      clientName
      entityId
      entityName
      client {
        id
        name
      }
      entity {
        id
        name
      }
      createdAt
      updatedAt
      dueDate
      slaStatus
      source
      externalRefId
      faPreparer
      faReviewer
      isPreparer
      isReviewer
      requestedBy
      statusCategory
      progress {
        completed
        total
        percentage
      }
      tasks {
        id
        name
        status
        gpxStatus
        executionState
        taskType
        stepOrder
        responsibleParty
        assignmentValue
        assignee {
          id
          displayName
        }
        dueDate
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalCount
    }
    viewerWorkflowUserId
  }
}
    `;

/**
 * __useGetControlTowerWorkflowsQuery__
 *
 * To run a query within a React component, call `useGetControlTowerWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetControlTowerWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetControlTowerWorkflowsQuery({
 *   variables: {
 *      assignedToUserIds: // value for 'assignedToUserIds'
 *      assignedToCurrentUser: // value for 'assignedToCurrentUser'
 *      clientIds: // value for 'clientIds'
 *      statuses: // value for 'statuses'
 *      workflowTypes: // value for 'workflowTypes'
 *      dueDateBefore: // value for 'dueDateBefore'
 *      dueDateAfter: // value for 'dueDateAfter'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useGetControlTowerWorkflowsQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>(GetControlTowerWorkflowsDocument, options);
      }
export function useGetControlTowerWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>(GetControlTowerWorkflowsDocument, options);
        }
// @ts-ignore
export function useGetControlTowerWorkflowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>;
export function useGetControlTowerWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetControlTowerWorkflowsQuery | undefined, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>;
export function useGetControlTowerWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>(GetControlTowerWorkflowsDocument, options);
        }
export type GetControlTowerWorkflowsQueryHookResult = ReturnType<typeof useGetControlTowerWorkflowsQuery>;
export type GetControlTowerWorkflowsLazyQueryHookResult = ReturnType<typeof useGetControlTowerWorkflowsLazyQuery>;
export type GetControlTowerWorkflowsSuspenseQueryHookResult = ReturnType<typeof useGetControlTowerWorkflowsSuspenseQuery>;
export type GetControlTowerWorkflowsQueryResult = Apollo.QueryResult<GraphqlTypes.GetControlTowerWorkflowsQuery, GraphqlTypes.GetControlTowerWorkflowsQueryVariables>;
export const GetWorkflowDocument = gql`
    query GetWorkflow($id: Int!) {
  workflow(id: $id) {
    id
    title
    templateName
    workflowType
    status
    currentStepName
    currentAssignee {
      id
      displayName
    }
    clientId
    clientName
    entityId
    entityName
    client {
      id
      name
    }
    entity {
      id
      name
    }
    createdAt
    updatedAt
    dueDate
    slaStatus
    source
    externalRefId
    faPreparer
    faReviewer
    isPreparer
    isReviewer
    requestedBy
    statusCategory
    progress {
      completed
      total
      percentage
    }
    tasks {
      id
      name
      status
      gpxStatus
      executionState
      taskType
      stepOrder
      responsibleParty
      assignmentValue
      nodeKind
      nodeKey
      requiresGpApproval
      assignee {
        id
        displayName
      }
      maker {
        id
        displayName
      }
      checker {
        id
        displayName
      }
      dueDate
      availableActions {
        action
        label
        variant
        requiresConfirmation
      }
      subtasks {
        id
        itemType
        label
        helpText
        isCompleted
        isRequired
        value
        options
        conditionalChildren
        config
        dataType
        uiSchema
        isCustom
      }
      mirroredSubtasks {
        id
        itemType
        label
        helpText
        isCompleted
        isRequired
        value
        options
        conditionalChildren
        config
        dataType
        uiSchema
        isCustom
      }
      activityLog {
        id
        occurredAt
        actorName
        actorId
        action
        note
        metaData
        taskId
        workflowId
      }
    }
    viewerWorkflowUserId
  }
}
    `;

/**
 * __useGetWorkflowQuery__
 *
 * To run a query within a React component, call `useGetWorkflowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkflowQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables> & ({ variables: GraphqlTypes.GetWorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>(GetWorkflowDocument, options);
      }
export function useGetWorkflowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
// @ts-ignore
export function useGetWorkflowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>;
export function useGetWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetWorkflowQuery | undefined, GraphqlTypes.GetWorkflowQueryVariables>;
export function useGetWorkflowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>(GetWorkflowDocument, options);
        }
export type GetWorkflowQueryHookResult = ReturnType<typeof useGetWorkflowQuery>;
export type GetWorkflowLazyQueryHookResult = ReturnType<typeof useGetWorkflowLazyQuery>;
export type GetWorkflowSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowSuspenseQuery>;
export type GetWorkflowQueryResult = Apollo.QueryResult<GraphqlTypes.GetWorkflowQuery, GraphqlTypes.GetWorkflowQueryVariables>;
export const GetGpUsersDocument = gql`
    query GetGpUsers($arenaId: Int!) {
  gpUsersForArena(arenaId: $arenaId) {
    id
    displayName
    email
  }
}
    `;

/**
 * __useGetGpUsersQuery__
 *
 * To run a query within a React component, call `useGetGpUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpUsersQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetGpUsersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables> & ({ variables: GraphqlTypes.GetGpUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>(GetGpUsersDocument, options);
      }
export function useGetGpUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>(GetGpUsersDocument, options);
        }
// @ts-ignore
export function useGetGpUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>;
export function useGetGpUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetGpUsersQuery | undefined, GraphqlTypes.GetGpUsersQueryVariables>;
export function useGetGpUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>(GetGpUsersDocument, options);
        }
export type GetGpUsersQueryHookResult = ReturnType<typeof useGetGpUsersQuery>;
export type GetGpUsersLazyQueryHookResult = ReturnType<typeof useGetGpUsersLazyQuery>;
export type GetGpUsersSuspenseQueryHookResult = ReturnType<typeof useGetGpUsersSuspenseQuery>;
export type GetGpUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetGpUsersQuery, GraphqlTypes.GetGpUsersQueryVariables>;
export const GetFaUsersDocument = gql`
    query GetFaUsers($arenaId: Int!) {
  faUsersForArena(arenaId: $arenaId) {
    id
    displayName
    email
  }
}
    `;

/**
 * __useGetFaUsersQuery__
 *
 * To run a query within a React component, call `useGetFaUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaUsersQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *   },
 * });
 */
export function useGetFaUsersQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables> & ({ variables: GraphqlTypes.GetFaUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>(GetFaUsersDocument, options);
      }
export function useGetFaUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>(GetFaUsersDocument, options);
        }
// @ts-ignore
export function useGetFaUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>;
export function useGetFaUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetFaUsersQuery | undefined, GraphqlTypes.GetFaUsersQueryVariables>;
export function useGetFaUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>(GetFaUsersDocument, options);
        }
export type GetFaUsersQueryHookResult = ReturnType<typeof useGetFaUsersQuery>;
export type GetFaUsersLazyQueryHookResult = ReturnType<typeof useGetFaUsersLazyQuery>;
export type GetFaUsersSuspenseQueryHookResult = ReturnType<typeof useGetFaUsersSuspenseQuery>;
export type GetFaUsersQueryResult = Apollo.QueryResult<GraphqlTypes.GetFaUsersQuery, GraphqlTypes.GetFaUsersQueryVariables>;
export const WorkflowDocumentsDocument = gql`
    query WorkflowDocuments($workflowId: Int!) {
  workflowDocuments(workflowId: $workflowId) {
    id
    taskId
    taskName
    documentId
    purpose
    isExternal
    document {
      id
      fileName
      fileSizeBytes
      contentType
      createdAt
    }
  }
}
    `;

/**
 * __useWorkflowDocumentsQuery__
 *
 * To run a query within a React component, call `useWorkflowDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowDocumentsQuery({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *   },
 * });
 */
export function useWorkflowDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables> & ({ variables: GraphqlTypes.WorkflowDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>(WorkflowDocumentsDocument, options);
      }
export function useWorkflowDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>(WorkflowDocumentsDocument, options);
        }
// @ts-ignore
export function useWorkflowDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>;
export function useWorkflowDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.WorkflowDocumentsQuery | undefined, GraphqlTypes.WorkflowDocumentsQueryVariables>;
export function useWorkflowDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>(WorkflowDocumentsDocument, options);
        }
export type WorkflowDocumentsQueryHookResult = ReturnType<typeof useWorkflowDocumentsQuery>;
export type WorkflowDocumentsLazyQueryHookResult = ReturnType<typeof useWorkflowDocumentsLazyQuery>;
export type WorkflowDocumentsSuspenseQueryHookResult = ReturnType<typeof useWorkflowDocumentsSuspenseQuery>;
export type WorkflowDocumentsQueryResult = Apollo.QueryResult<GraphqlTypes.WorkflowDocumentsQuery, GraphqlTypes.WorkflowDocumentsQueryVariables>;
export const GetJiraChildWorkItemsDocument = gql`
    query GetJiraChildWorkItems($parentIssueKey: String!) {
  childWorkItems(parentIssueKey: $parentIssueKey) {
    parentKey
    items {
      id
      key
      summary
      status
      statusCategoryName
      assignedTo {
        displayName
      }
      fundAdministrationDepartment
    }
  }
}
    `;

/**
 * __useGetJiraChildWorkItemsQuery__
 *
 * To run a query within a React component, call `useGetJiraChildWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJiraChildWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJiraChildWorkItemsQuery({
 *   variables: {
 *      parentIssueKey: // value for 'parentIssueKey'
 *   },
 * });
 */
export function useGetJiraChildWorkItemsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables> & ({ variables: GraphqlTypes.GetJiraChildWorkItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>(GetJiraChildWorkItemsDocument, options);
      }
export function useGetJiraChildWorkItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>(GetJiraChildWorkItemsDocument, options);
        }
// @ts-ignore
export function useGetJiraChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>;
export function useGetJiraChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.GetJiraChildWorkItemsQuery | undefined, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>;
export function useGetJiraChildWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>(GetJiraChildWorkItemsDocument, options);
        }
export type GetJiraChildWorkItemsQueryHookResult = ReturnType<typeof useGetJiraChildWorkItemsQuery>;
export type GetJiraChildWorkItemsLazyQueryHookResult = ReturnType<typeof useGetJiraChildWorkItemsLazyQuery>;
export type GetJiraChildWorkItemsSuspenseQueryHookResult = ReturnType<typeof useGetJiraChildWorkItemsSuspenseQuery>;
export type GetJiraChildWorkItemsQueryResult = Apollo.QueryResult<GraphqlTypes.GetJiraChildWorkItemsQuery, GraphqlTypes.GetJiraChildWorkItemsQueryVariables>;